import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import { noop } from 'utils/func';
import { Consumer } from 'utils/BowserProvider';
import { getNonPassiveHandlerOptions } from 'utils/detectPassiveEvents';

let fixIpadBugWithCancelBodyScrollingFixed = false;
function fixIpadBugWithCancelBodyScrolling() {
  if (!fixIpadBugWithCancelBodyScrollingFixed) {
    window.addEventListener('touchmove', noop, getNonPassiveHandlerOptions());
    fixIpadBugWithCancelBodyScrollingFixed = true;
  }
}

class BrowserSpecificInternal extends PureComponent {
  static propTypes = {
    bowser: PropTypes.object.isRequired,
  };

  componentDidMount() {
    // iOS >= 10 bug with impossible to cancel body scrolling on touchmove event
    // https://github.com/metafizzy/flickity/issues/457
    fixIpadBugWithCancelBodyScrolling();
  }

  render() {
    if (!this.props.bowser.ios) {
      return null;
    }

    // iOS touch devices: iphone/ipad/ipod - fix missing blur event on body tap
    // It has to be done as an attribute as React Helmet doesn't support css class appending
    return (
      <Helmet>
        <html data-fix-ios-touch="true" />{/* eslint-disable-line jsx-a11y/html-has-lang */}
      </Helmet>
    );
  }
}

const BrowserSpecific = (props) => (
  <Consumer>
    {bowser => <BrowserSpecificInternal bowser={bowser} {...props} />}
  </Consumer>
);

export default BrowserSpecific;
